/*global VeloxGridAndFormController*/


var renewNotifController = new VeloxGridAndFormController("renew_notif", {
    grid : {
        directory: "views/reseller",
        name: "renewNotifGrid",
    },
    form : {
        directory: "views/reseller",
        name: "renewNotifForm",
    }
});

module.exports = renewNotifController ;